import React, { useEffect, useRef } from 'react';

import useVisibility from 'V2/Hooks/useVisibility';
import { useFullstory } from 'V2/Hooks/useFullstory';

import styles from './styles.module.css';

type FieldErrorProps = React.PropsWithChildren<{
  'data-testid'?: string;
  analyticsId?: string;
}>;

export const FieldError: React.FC<FieldErrorProps> = ({
  children,
  analyticsId,
  'data-testid': dataTestId,
}) => {
  const errorRef = useRef<HTMLDivElement | null>(null);

  const { isVisible: isErrorVisible } = useVisibility(errorRef, { once: true });

  const { fsCommands } = useFullstory();
  const { trackFieldErrorShown } = fsCommands;

  useEffect(() => {
    if (!isErrorVisible || !analyticsId) return;

    trackFieldErrorShown({
      analyticsId,
      info: typeof children === 'string' ? { errorText: children } : {},
    });
  }, [isErrorVisible, children, analyticsId, trackFieldErrorShown]);

  const errorAttributes = analyticsId
    ? {
        'data-fs-element': `Error ${analyticsId}`,
        'data-fs-properties-schema': 'error_text:textContent',
      }
    : {};

  return (
    <div
      {...errorAttributes}
      data-testid={dataTestId}
      className={styles.error}
      ref={errorRef}
    >
      {children}
    </div>
  );
};
